import { render } from "./MenusItemsTableRow.vue?vue&type=template&id=519c888d"
import script from "./MenusItemsTableRow.vue?vue&type=script&lang=js"
export * from "./MenusItemsTableRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__